import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import Head from 'next/head';
import { t } from '@sizzlenz/shared';
import AboutNZ from '@/components/AboutNZ';
import AboutUS from '@/components/AboutUS';
export default function AboutPage() {
  const $ = _c(4);
  let t0;
  bb0: switch (process.env.SIZZLE_PLATFORM) {
    case "sizzlecpg":
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <AboutUS />;
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        t0 = t1;
        break bb0;
      }
    default:
      {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <AboutNZ />;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        t0 = t1;
      }
  }
  const component = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <title>{t("about.pageTitle")}</title>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <><Head>{t1}<meta name="description" content={t("about.metaDescription")} /></Head>{component}</>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}